import React from "react";
import { useTranslation } from "react-i18next";
import { VelavuRoute } from "velavu-js-api";
import Divider from "../../../../elements/divider";
import DeviceRoutesDetail from "./device-routes-detail";
import DeviceRoutesItem from "./device-routes-item";
import * as styles from "./device-routes.module.scss";
import { NoTripIcon } from "../../../../img/icons/icons";

interface RoutesProps {
	routes?: VelavuRoute[];
	hoveredRouteID?: string;
	onHoverRoute: (route?: VelavuRoute) => void;
	selectedRoute?: VelavuRoute;
	onSelectRoute: (route: VelavuRoute | undefined) => void;
	onDeleteRoute: (route: VelavuRoute) => void;
}

function NoTrips() {
	const { t } = useTranslation();

	return (
		<div className={styles.emptyContent}>
			<NoTripIcon />
			<span className={styles.heading}>
				{t("dashboard.routes.no_trips")}
			</span>
			<span className={styles.info}>
				{t("dashboard.routes.no_trips_hint")}
			</span>
		</div>
	);
}

export default function DeviceRoutes(props: RoutesProps) {
	const { t } = useTranslation();

	if (!props.routes) {
		return (
			<div className={styles.empty}>
				<span>{t("dashboard.routes.checking")}</span>
			</div>
		);
	} else if (props.routes.length === 0) {
		return <NoTrips />;
	} else {
		return (
			<>
				{props.routes.map((route, index) => (
					<React.Fragment key={route.id}>
						{index > 0 && <Divider />}
						<DeviceRoutesItem
							route={route}
							isHovered={props.hoveredRouteID === route.id}
							onHover={() => props.onHoverRoute(route)}
							onHoverExit={() =>
								props.hoveredRouteID === route.id &&
								props.onHoverRoute(undefined)
							}
							isSelected={props.selectedRoute?.id === route.id}
							onSelect={props.onSelectRoute}
						/>
						{props.selectedRoute?.id === route.id && (
							<DeviceRoutesDetail
								route={props.selectedRoute}
								onDeleteRoute={() =>
									props.selectedRoute &&
									props.onDeleteRoute(props.selectedRoute)
								}
							/>
						)}
					</React.Fragment>
				))}
			</>
		);
	}
}
